'use es6'; // Black, grays and whites

var PRIMARYBLACK = '#000000';
var CODGRAY = '#111111';
var ASPHALT = '#2F2F2F';
var MINESHAFT = '#333333';
var TUNDORA = '#4A4A4A';
var EBONYCLAY = '#253342';
var NEPAL = '#99ACC2';
var COSMIC = '#6E344B';
var DOVEGRAY = '#666666';
var DUSTYGRAY = '#9B9B9B';
var SILVERCHALICE = '#999999';
var SILVER = '#CCCCCC';
var ALTO = '#DBDBDB';
var MERCURY = '#E5E5E5';
var GALLERY = '#F0F0F0';
var PRIMARYWHITE = '#FFFFFF';
var CATSKILLWHITE = '#F5F8FA'; // All other colors

var BURNTSIENNA = '#E66E50';
var PICKLEDBLUEWOODALT2 = '#2F4050';
var PICKLEDBLUEWOODALT = '#33475B';
var PICKLEDBLUEWOOD = '#2D3E50';
var BLEUDEFRANCE = '#297BED';
var CHAMBRAY = '#3B5998';
var PICTONBLUE = '#55ACEE';
var ATLANTIS = '#A4BA32';
var MONZA = '#D00243';
var KOBI = '#E8A8BC';
var ZUMTHOR = '#EEF7FF';
var TANGO = '#F47621';
var PRIMARYORANGE = '#F4762F';
var CRUSTA = '#FA862A';
var FLUSHORANGE = '#FF7700';
var LIGHTNINGYELLOW = '#F8BE1C';
var HITPINK = '#FEB48F';
var BONDIBLUE = '#0091B0';
var CORAL = '#FF7A59 ';
var ATOMICTANGERINE = '#FF8F59 ';
var CARIBBEANGREEN = '#00BDA5 ';
var CARNATION = '#F2545B';
var MOODYBLUE = '#6A78D1';
var PACIFICBLUE = '#00A4BD';
var RAJAH = '#F5C26B';
var WILDBLUEYONDER = '#7C98B6';
var KASHMIRBLUE = '#516F90';
var MYSTIC = '#DFE3EB';
var SANJUAN = '#2F5363';
var OUTERSPACE = '#1B2628';
export var colors = {
  PRIMARYBLACK: PRIMARYBLACK,
  CODGRAY: CODGRAY,
  ASPHALT: ASPHALT,
  MINESHAFT: MINESHAFT,
  TUNDORA: TUNDORA,
  EBONYCLAY: EBONYCLAY,
  NEPAL: NEPAL,
  COSMIC: COSMIC,
  DOVEGRAY: DOVEGRAY,
  DUSTYGRAY: DUSTYGRAY,
  SILVERCHALICE: SILVERCHALICE,
  SILVER: SILVER,
  ALTO: ALTO,
  MERCURY: MERCURY,
  GALLERY: GALLERY,
  PRIMARYWHITE: PRIMARYWHITE,
  CATSKILLWHITE: CATSKILLWHITE,
  BURNTSIENNA: BURNTSIENNA,
  PICKLEDBLUEWOODALT2: PICKLEDBLUEWOODALT2,
  PICKLEDBLUEWOODALT: PICKLEDBLUEWOODALT,
  PICKLEDBLUEWOOD: PICKLEDBLUEWOOD,
  BLEUDEFRANCE: BLEUDEFRANCE,
  CHAMBRAY: CHAMBRAY,
  PICTONBLUE: PICTONBLUE,
  ATLANTIS: ATLANTIS,
  MONZA: MONZA,
  KOBI: KOBI,
  ZUMTHOR: ZUMTHOR,
  TANGO: TANGO,
  PRIMARYORANGE: PRIMARYORANGE,
  CRUSTA: CRUSTA,
  FLUSHORANGE: FLUSHORANGE,
  LIGHTNINGYELLOW: LIGHTNINGYELLOW,
  HITPINK: HITPINK,
  BONDIBLUE: BONDIBLUE,
  CORAL: CORAL,
  ATOMICTANGERINE: ATOMICTANGERINE,
  CARIBBEANGREEN: CARIBBEANGREEN,
  CARNATION: CARNATION,
  MOODYBLUE: MOODYBLUE,
  PACIFICBLUE: PACIFICBLUE,
  RAJAH: RAJAH,
  WILDBLUEYONDER: WILDBLUEYONDER,
  KASHMIRBLUE: KASHMIRBLUE,
  MYSTIC: MYSTIC,
  SANJUAN: SANJUAN,
  OUTERSPACE: OUTERSPACE
};